export const mealAccents = {
  breakfast: { color: "#f59e0b", bg: "rgba(251,191,36,0.12)",  border: "rgba(251,191,36,0.45)",  iconBg: "rgba(251,191,36,0.18)", circleColor: "#D4A84B" },
  lunch:     { color: "#22c55e", bg: "rgba(34,197,94,0.12)",   border: "rgba(34,197,94,0.45)",   iconBg: "rgba(34,197,94,0.18)",  circleColor: "#7A9872" },
  dinner:    { color: "#e07070", bg: "rgba(224,112,112,0.1)",  border: "rgba(224,112,112,0.4)",  iconBg: "rgba(224,112,112,0.18)",circleColor: "#D4836A" },
  snacks:    { color: "#a0906a", bg: "rgba(160,144,106,0.1)",  border: "rgba(160,144,106,0.4)",  iconBg: "#fce7c8",               circleColor: "#C4956A" },
};

export const mealTypeColors = {
  breakfast: "#f59e0b",
  lunch:     "#22c55e",
  dinner:    "#e07070",
  snacks:    "#a0906a",
};
